import { Component } from '@angular/core';
import { LateralBarComponent } from './components/lateral-bar/lateral-bar.component';
import { FloatBarComponent } from '../../shared/components/float-bar/float-bar.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-modules',
    imports: [LateralBarComponent, RouterOutlet, FloatBarComponent],
    templateUrl: './modules.component.html',
    styleUrl: './modules.component.scss'
})
export class ModulesComponent {

}
